
import {css} from "lit"
export default css`

:host {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2em;
}

section {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 0.1em;

	width: 100%;

	> h2 {
		font-size: 1em;
		opacity: 0.3;
		padding: 0 1em;
		text-transform: uppercase;
		font-family: sans-serif;
		font-weight: bold;
		text-align: left;
		align-self: start;
	}

	> div {
		display: flex;
		flex-direction: column;
		gap: 0.5em;
	}

	textarea {
		min-height: 6em;
		padding: 0.5em;
	}

	[view="slate"] {
		width: 100%;
	}
}

.timepicker {
	font-size: 0.7em;
	padding: 0.5em;
}

.input {
	border-radius: 0.5em;
	color: white;
	background: #0004;
	border: 0.1em solid color-mix(in lch, transparent, currentColor 10%);
	border-radius: 0.5em;
}

@media (width > 400px) { .timepicker { font-size: 1em; } }
@media (width > 600px) { .timepicker { font-size: 1.3em; } }

small {
	opacity: 0.5;
	font-size: 0.8em;
	text-align: right;
	padding: 0 1em;
}

.timelink {
	display: block;
	background: color-mix(in oklch, transparent, var(--link) 5%);
	border-color: color-mix(in oklch, transparent, var(--link) 20%);
	width: 100%;

	font-family: sans-serif;
	font-size: 1.3em;
	word-break: break-all;
	text-shadow:
		0 0 1em var(--link),
		0 0 3em white;
}

`
